<template>
  <div class="selectplan">
    <h1 class="txt-center" style="font-size: 28px; margin-bottom: 18px;">
        Escolha a quantidade de WhatsApp Adicionais
    </h1>
    <div class="grid margin-top-l row">
        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center middle">
              <h2>1x Whatsapp</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content middle">
                <ul class="margin-top-m">
                  <li>1 whatsapp adicional</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 59,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[0])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l no-mobile">
          <div class="box-title flex center middle">
              <h2>5x WhatsApp</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content middle">
                <ul class="margin-top-m">
                  <li>5 whatsapps adicionais</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 299,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[1])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div class="flex-1 box margin-top-l">
          <div class="box-title flex center">
              <h2>10x WhatsApp</h2>
            </div>
            <div class="box-content column flex middle">
              <div class="margin-top-l flex column w100 content middle">
                <ul class="margin-top-m">
                  <li>10 whatsapps adicionais</li>
                </ul>
              </div>
              <div class="margin-top-l action flex w100 column middle">
                <div class="margin-top-l flex flex-1 w100 column middle">
                  <h3>R$ 599,90 / mês</h3>
                  <small class="margin-top-s">*pagamento mensal</small>
                </div>
                <div @click="updateAccount(urlPlan[2])">
                  <div class="button primary margin-top-l">
                    Assinar
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "subscription",
  components: {},
  props: ["slug"],
  data() {
    return {
      loading: false,
      urlPlan: [
        "https://pay.kiwify.com.br/cMmn4BG", // 1x
        "https://pay.kiwify.com.br/jcQYUn2", // 5x
        "https://pay.kiwify.com.br/47atDTq", // 10x
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    adjustUrl(url) {
      if (!this.account) {
        return
      }
      if (this.account.afiliate_kiwify_code) {
        return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}&afid=${this.account.afiliate_kiwify_code}`
      }
      return `${url}?name=${this.account.name}&email=${this.account.email}&phone=${this.account.phone}&utm_source=ACC${this.account.id}`
    },
    updateAccount(url) {
        var urlf = this.adjustUrl(url)
        document.location.href = urlf
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-width: 150px;
  min-height: 130px;
  margin-top: 16px;
  margin-left: 0px !important;
  margin-right: 20px;

  a {
    width: 100%;
    height: 100%;

    &:hover {
      color:#fff;
    }
  }
}

.disabled-box {
  background: #e8e8e8;
  > a {
    cursor: none;
  }
}

.tag {
  background: var(--primary);
  color: #fff;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
}

.destaque {
  color: var(--terciary) !important;
  font-size: 32px;
}

.selectplan {

  .de-price {
    color: #666;
  }

  .promo {
    position: absolute;
    top: 20px;
    padding: 8px 16px;
    background: yellow;
    color: #000;
    border-radius: 4px;
    font-weight: 800;
  }

  .box {
    .box-content {
      position: relative;
      .content {
        min-height: 55px;
      }
      ul {
        margin-left: 14px;
        li {
          padding: 4px;
        }
      }

      .action {
        border-top: 1px solid #00000022;
      }
    }
    .box-title {
      padding: 4px 15px;
      h2 {
        font-size: 28px;
        font-weight: 800;
      }
    }
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
